
export default function quantizeNumber(val: number, quantum: number, cover = false) {
    if (!quantum) { return 0 }
    const remainder = val % quantum
    const sign = val >= 0 ? 1 : -1
    const mod = cover && remainder ? quantum : 0
    return val - remainder + sign * mod
}
